export const headingXL = `
  font-family: Calibre-Semibold, sans-serif;
  font-size: 48px;
  font-weight: 600;
  line-height: 56px;
`;
export const headingLG = `
  font-family: Calibre-Semibold, sans-serif;
  font-size: 36px;
  font-weight: 600;
  line-height: 42px;
`;
export const headingMD = `
  font-family: Calibre-Semibold, sans-serif;
  font-size: 26px;
  font-weight: 600;
  line-height: 32px;
`;
export const headingSM = `
  font-family: Calibre-Semibold, sans-serif;
  font-size: 22px;
  font-weight: 600;
  line-height: 32px;
`;
export const headingXS = `
  font-family: Calibre-Semibold, sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
`;
// Body Styles
export const bodyLG = `
  font-family: Calibre-Regular, sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
`;
export const bodyMD = `
  font-family: Calibre-Regular, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
`;
export const bodySM = `
  font-family: Calibre-Regular, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;
// Misc
export const button = `
  font-family: Calibre-Medium, sans-serif;
  font-size: 17px;
  font-weight: 500;
  line-height: 24px;
`;
export const label = `
  font-family: Calibre-Medium, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
`;
